<template>
  <div
    style="
      padding: 0rem 2rem;
      width: 100%;
      height: calc(100% - 9.5rem);
      position: absolute;
    "
  >
    <div class="w-100 d-flex justify-content-between" style="height: 20%">
      <div
        v-for="(a, index) in orderGrowthRateData"
        :key="index"
        style="width: 24.25%; height: 100%; min-width: 26.75rem"
        class="cardCss d-flex"
      >
        <div
          class="d-flex flex-wrap align-items-center align-content-between"
          style="height: 100%; width: 50%"
        >
          <div class="w-100 d-flex align-items-center">
            <img
              v-show="index == 0"
              style="width: 1.375rem; height: 1.375rem"
              src="../../assets/images/dashboard/setting.png"
              alt=""
            />
            <img
              v-show="index == 1"
              style="width: 1.375rem; height: 1.375rem"
              src="../../assets/images/dashboard/line.png"
              alt=""
            />
            <img
              v-show="index == 2"
              style="width: 1.375rem; height: 1.375rem"
              src="../../assets/images/dashboard/loading.png"
              alt=""
            />
            <img
              v-show="index == 3"
              style="width: 1.375rem; height: 1.375rem"
              src="../../assets/images/dashboard/check.png"
              alt=""
            />
            <div
              style="font-size: 1.25rem; color: #b6b7bc; font-weight: 400"
              class="ms-2"
            >
              {{
                [
                  $t("overview_static.work_order_page.work_order_amount"),
                  $t("overview_static.work_order_page.order_in_progress"),
                  $t("overview_static.work_order_page.order_in_this_month"),
                  $t("overview_static.work_order_page.completed_in_this_month"),
                ][index]
              }}
            </div>
          </div>

          <div
            class="w-100 text-white fw-bold ms-4"
            style="font-size: 2rem; padding-left: 1.375rem"
          >
            {{ a.count }}{{ $t('overview_static.common["单"]') }}
          </div>
          <div></div>
        </div>
        <div
          class="d-flex h-100 flex-wrap align-items-center align-content-center"
          style="width: 50%; height: 100%"
        >
          <div v-if="index == 0" class="d-flex align-items-end">
            <div style="font-size: 2rem; line-height: 2rem">
              {{ a.year_count }}{{ $t('overview_static.common["单"]') }}
            </div>
            <div style="font-size: 0.75rem; font-weight: 300">
              {{ $t("今年") }}
            </div>
          </div>

          <div
            v-if="index == 2 || index == 3"
            class="w-100 d-flex justify-content-start align-items-center mt-4"
            style="position: relative"
          >
            <img
              style="width: 2.0625rem; height: 0.9375rem"
              :src="
                a.yoy && a.yoy > 0
                  ? require('../../assets/images/equipmentDashboard/up.png')
                  : require('../../assets/images/equipmentDashboard/down.png')
              "
              alt=""
            />
            <div
              class="ms-2"
              style="width: 100px; font-size: 1rem; font-weight: 600"
              :style="{ color: a.yoy && a.yoy > 0 ? '#11cabe' : '#F77474' }"
            >
              {{ Number(a.yoy && a.yoy).toFixed(2) }} %
            </div>
            <div style="font-size: 0.75rem; font-weight: 300">
              {{
                [
                  $t("overview_static.work_order_page.compared_to_last_year"),
                  $t("overview_static.work_order_page.compared_to_last_year"),
                  $t("overview_static.work_order_page.month_on_month"),
                  $t("overview_static.work_order_page.month_on_month"),
                ][index]
              }}
            </div>
          </div>
          <div
          v-if="index===0||index===1"
            class="w-100 d-flex justify-content-start align-items-center mt-2"
            style="position: relative"
          >
            <img
              style="width: 2.0625rem; height: 0.9375rem"
              :src="
               Number(a&&a.growth_rate&&a.growth_rate.length>0&&a.growth_rate[a.growth_rate.length-1].rate) > 0
                  ? require('../../assets/images/equipmentDashboard/up.png')
                  : require('../../assets/images/equipmentDashboard/down.png')
              "
              alt=""
            />
            <div
              class="ms-2"
              style="width: 100px; font-size: 1rem; font-weight: 600"
              :style="{
                color:
                Number(a&&a.growth_rate&&a.growth_rate.length>0&&a.growth_rate[a.growth_rate.length-1].rate) > 0
                    ? '#11cabe'
                    : '#F77474',
              }"
            >
           {{ Number(a&&a.growth_rate&&a.growth_rate.length>0&&a.growth_rate[a.growth_rate.length-1].rate).toFixed(2) }} %
            </div>
            <div
              v-if="index == 2 || index == 3"
              style="font-size: 0.75rem; font-weight: 300"
            >
              {{
                [
                  $t("overview_static.work_order_page.compared_to_last_year"),
                  $t("overview_static.work_order_page.compared_to_last_year"),
                  $t("overview_static.work_order_page.month_by_month"),
                  $t("overview_static.work_order_page.month_by_month"),
                ][index]
              }}
            </div>
          </div>
          <div
          v-if="index===2||index===3"
            class="w-100 d-flex justify-content-start align-items-center mt-2"
            style="position: relative"
          >
            <img
              style="width: 2.0625rem; height: 0.9375rem"
              
              :src="
              a.mom && a.mom > 0
                  ? require('../../assets/images/equipmentDashboard/up.png')
                  : require('../../assets/images/equipmentDashboard/down.png')
              "
              alt=""
            />
            <div
              class="ms-2"
              style="width: 100px; font-size: 1rem; font-weight: 600"
              :style="{ color: a.mom && a.mom > 0 ? '#11cabe' : '#F77474' }"
            >
            {{ Number(a.mom && a.mom).toFixed(2) }} %
            </div>
            <div
              v-if="index == 2 || index == 3"
              style="font-size: 0.75rem; font-weight: 300"
            >
              {{
                [
                  $t("overview_static.work_order_page.compared_to_last_year"),
                  $t("overview_static.work_order_page.compared_to_last_year"),
                  $t("overview_static.work_order_page.month_by_month"),
                  $t("overview_static.work_order_page.month_by_month"),
                ][index]
              }}
            </div>
          </div>
          <div
            v-if="index == 0||index == 1"
            class="w-100 mt-2"
            style="font-size: 0.75rem; font-weight: 300"
          >
           {{
            getGrowthRateDelta(a)
            }}
            {{ $t('overview_static.common["单"]') }}
            {{
              [
                $t("overview_static.work_order_page.compared_to_last_year"),
                $t("overview_static.work_order_page.compared_to_last_month"),
                $t("overview_static.work_order_page.month_by_month"),
                $t("overview_static.work_order_page.month_by_month"),
              ][index]
            }}
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 1.25rem; width: 100%; height: 39%">
      <div class="d-flex w-100 h-100 justify-content-between">
        <div
          style="width: 24.3%; height: 100%; max-height: 27rem"
          class="cardCss"
        >
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{ $t("overview_static.work_order_page.order_status") }}
            </div>
            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}:
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate1"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getOrderStatus"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>
          <div id="opportunityEchart" style="width: 100%; height: 90%"></div>
          <!--             <div  v-if="false" class="w-100 mt-2 d-flex justify-content-end">-->
          <!--              <div-->

          <!--                class="btnClass"-->
          <!--                style="-->
          <!--                  width: 5.625rem;-->
          <!--                  text-align: center;-->
          <!--                  line-height: 1.25rem;-->
          <!--                  height: 1.25rem;-->
          <!--                "-->
          <!--              >-->
          <!--                {{ $t("overview_static.common.details") }}-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
        <div
          style="width: 49.3%; height: 100%; max-height: 27rem"
          class="cardCss"
        >
          <div class="w-100 d-flex justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{ $t("overview_static.work_order_page.order_trend") }}
            </div>
            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}:
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate2"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getOrderStatusAnalysis"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>
          <div
            id="workOrderStatisticsEchart"
            style="width: 100%; height: 90%"
          ></div>
          <!--            <div-->
          <!--                v-if="false"-->
          <!--              style="width: 100%"-->
          <!--              class="d-flex mt-2 align-items-end justify-content-end"-->
          <!--            >-->
          <!--              <div-->
          <!--                class="btnClass"-->
          <!--                style="-->
          <!--                  width: 5.625rem;-->
          <!--                  text-align: center;-->
          <!--                  line-height: 1.25rem;-->
          <!--                  height: 1.25rem;-->
          <!--                "-->
          <!--              >-->
          <!--                {{ $t("overview_static.common.details") }}-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
        <div
          style="width: 24.3%; height: 100%; max-height: 27rem"
          class="cardCss"
        >
          <div class="w-100 d-flex justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{ $t("page.work-order.type.text") }}
            </div>

            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}:
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate3"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getOrderType"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>
          <div id="opportunity" style="width: 100%; height: 90%"></div>
          <!--             <div  v-if="false" class="w-100 mt-2 d-flex justify-content-end">-->
          <!--              <div-->
          <!--                class="btnClass"-->
          <!--                style="-->
          <!--                  width: 5.625rem;-->
          <!--                  text-align: center;-->
          <!--                  line-height: 1.25rem;-->
          <!--                  height: 1.25rem;-->
          <!--                "-->
          <!--              >-->
          <!--                {{ $t("overview_static.common.details") }}-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
      </div>
    </div>
    <div style="margin-top: 1.25rem; width: 100%; height: 39%">
      <div class="d-flex w-100 h-100 justify-content-between">
        <div
          style="width: 38%; height: 100%"
          class="cardCss d-flex flex-wrap align-content-between"
        >
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{ $t("overview_static.work_order_page.order_feedback") }}
            </div>
            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}:
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate4"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getOrderFeedback"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-between ms-4 me-4">
            <div v-for="a in timeList" :key="a.name" style="height: 5rem">
              <div class="fs-15" style="color: #b6b7bc">{{ a.name }}</div>
              <div class="fs-20 mt-2" style="color: #fff">{{ a.value }}</div>
            </div>
            <div style="width: 21.875rem">
              <div class="fs-15" style="color: #b6b7bc">
                {{
                  $t(
                    "overview_static.dahsboard_page.customer_satisfaction_score"
                  )
                }}
              </div>
              <div
                class="d-flex justify-content-between align-content-center align-items-center"
              >
                <div
                  id="scheduleEchart"
                  style="width: 16rem; height: 1.875rem"
                ></div>
                <div class="fs-15">
                  {{ customerSatisfaction }}
                  {{ $t('overview_static.common["分"]') }} / 5
                  {{ $t('overview_static.common["分"]') }}
                </div>
              </div>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-between" style="height: 50%">
            <div id="inTime" style="height: 90%; width: 20%"></div>
            <div id="inTime2" style="height: 90%; width: 20%"></div>
            <div id="inTime3" style="height: 90%; width: 20%"></div>
            <div id="inTime4" style="height: 90%; width: 20%"></div>
          </div>
          <!--            <div  v-if="false" class="w-100 mt-2 d-flex justify-content-end">-->
          <!--              <div-->
          <!--                class="btnClass"-->
          <!--                style="-->
          <!--                  width: 5.625rem;-->
          <!--                  text-align: center;-->
          <!--                  line-height: 1.25rem;-->
          <!--                  height: 1.25rem;-->
          <!--                "-->
          <!--              >-->
          <!--                {{ $t("overview_static.common.details") }}-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
        <div
          style="width: 30%"
          class="h-100 cardCss d-flex flex-wrap align-content-between"
        >
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{ $t("overview_static.dahsboard_page.map_area.workload") }}
            </div>
            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}:
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate6"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getOrderIndustry"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>

          <div id="industryEchart" style="width: 100%; height: 90%"></div>
          <!--            <div v-if="false" class="w-100 mt-2 d-flex justify-content-end">-->
          <!--              <div-->
          <!--                class="btnClass"-->
          <!--                style="-->
          <!--                  width: 5.625rem;-->
          <!--                  text-align: center;-->
          <!--                  line-height: 1.25rem;-->
          <!--                  height: 1.25rem;-->
          <!--                "-->
          <!--              >-->
          <!--                {{ $t("overview_static.common.details") }}-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
        <div
          style="width: 30%"
          class="h-100 cardCss d-flex flex-wrap align-content-between"
        >
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{
                $t(
                  "overview_static.work_order_page.order_distribution_on_industry"
                )
              }}
            </div>
            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}:
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate5"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getOrderIndustry"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>

          <div id="industryEchart1" style="width: 100%; height: 90%"></div>
          <!--            <div  v-if="false" class="w-100 mt-2 d-flex justify-content-end">-->
          <!--              <div-->
          <!--                class="btnClass"-->
          <!--                style="-->
          <!--                  width: 5.625rem;-->
          <!--                  text-align: center;-->
          <!--                  line-height: 1.25rem;-->
          <!--                  height: 1.25rem;-->
          <!--                "-->
          <!--              >-->
          <!--                {{ $t("overview_static.common.details") }}-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { tendencyEcharts } from "@/utils/equipmentDashboard";
import {
  workOrderStatisticsEcharts,
  opportunityEcharts,
  scheduleEcharts,
  pieEcharts,
  industryEcharts,
  lineEchart,
} from "@/utils/workOrderDashboard";
import { API_SVC_HOST } from "@/config/common";
import _ from "lodash";

import {
  orderStatus,
  orderStatusAnalysis,
  orderFeedback,
  orderIndustry,
  orderGrowthRate,
  orderType,
  monthlyWorkload,
} from "@/service/index";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { ref } from "vue";

export default {
  components: {
    flatPickr,
  },
  data() {
    return {
      timeList: [
        {
          name: this.$t("overview_static.work_order_page.ave_response_speed"),
          value: "0",
        },
        {
          name: this.$t("overview_static.work_order_page.response_to_arr"),
          value: "0",
        },
        {
          name: this.$t("overview_static.work_order_page.ave_fix"),
          value: "0",
        },
      ],
      startDateConfig: {
        wrap: true,
        altInput: true,
        altFormat: "Y-m-d", //选择时显 fs-12示的时间:
        dateFormat: "Y-m-d",
        mode: "range",
        allowInput: true, //是否允许用户直接在输入框中输入日期。
        appendTo: document.getElementById("app"),
      },
      /* moment().subtract(1, "year").format("YYYY-MM-DD") */
      repairDate1:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate2:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate3:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate4:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate5:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate6:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      timmer: null,
      timeData: "",
      yearData: "",
      weekData: "",
      fullscreen: false,
      pathType: "work-order-dashboard",
      customerSatisfaction: 0,
      //   orderGrowthRateData: [],
    };
  },
  setup() {
    const orderGrowthRateData = ref([
      { count: "", growth_rate: "", yoy: "", mom: "", year_count: "" },
      { count: "", growth_rate: "", yoy: "", mom: "", year_count: "" },
      { count: "", growth_rate: "", yoy: "", mom: "", year_count: "" },
      { count: "", growth_rate: "", yoy: "", mom: "", year_count: "" },
    ]);
    const nameList = ref(["total", "tracking", "current", "completed"]);
    orderGrowthRate({
      start: moment().subtract(1, "month").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
    }).then((res) => {
      if (res && res.payload) {
        orderGrowthRateData.value = setData(res.payload);
      }
      console.log(orderGrowthRateData, nameList);
    });
    function setData(data) {
      var list = [];
      nameList.value.forEach((item) => {
        list.push({ ...data[item] });
      });
      return list;
    }
    return {
      orderGrowthRateData,
      nameList,
    };
  },
  methods: {
    getGrowthRateDelta(item) {
      const growthRates = Array.isArray(item?.growth_rate) ? item.growth_rate : [];
      const latestValue = Number(growthRates[growthRates.length - 1]?.value ?? 0);
      const previousValue = Number(growthRates[growthRates.length - 2]?.value ?? 0);
      if (!Number.isFinite(latestValue) || !Number.isFinite(previousValue)) return 0;
      return Number((latestValue - previousValue).toFixed(2));
    },
    logout() {
      var form = document.getElementById("frm_logout");
      form.action = this.logoutUrl;
      form.submit();
      sessionStorage.setItem("is_logout", "true");
      setTimeout(() => {
        localStorage.clear();
      }, 2000);
    },
    //同比环比
    // getOrderGrowthRate() {
    //   orderGrowthRate().then((res) => {
    //     if (res && res.payload) {
    //         ["total", "tracking", "current", "completed"].forEach((item) => {
    //           this.orderGrowthRateData.push({ ...res.payload[item] });
    //         });
    //     }
    //   });
    // },
    getOrderStatus() {
      let params = {
        start:
          moment(
            this.repairDate1.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate1.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      orderStatus(params).then((res) => {
        if (res && res.payload) {
          opportunityEcharts({
            chartDom: document.getElementById("opportunityEchart"),
            unit: this.$t('overview_static.common["单"]'),
            allNum:
              (res.payload["已完成"] || 0) +
              (res.payload["已取消"] || 0) +
              (res.payload["施工中"] || 0) +
              (res.payload["待施工"] || 0) +
              (res.payload["待转派"] || 0) +
              (res.payload["待确认"] || 0) +
              (res.payload["待派工"] || 0),
            dataList: [
              {
                name: this.$t('overview_dynamic.order_status_dict["已完成"]'),
                value: res.payload["已完成"] || 0,
              },
              {
                name: this.$t('overview_dynamic.order_status_dict["已取消"]'),
                value: res.payload["已取消"] || 0,
              },
              {
                name: this.$t('overview_dynamic.order_status_dict["施工中"]'),
                value: res.payload["施工中"] || 0,
              },
              {
                name: this.$t('overview_dynamic.order_status_dict["待施工"]'),
                value: res.payload["待施工"] || 0,
              },
              {
                name: this.$t('overview_dynamic.order_status_dict["待转派"]'),
                value: res.payload["待转派"] || 0,
              },
              {
                name: this.$t('overview_dynamic.order_status_dict["待确认"]'),
                value: res.payload["待确认"] || 0,
              },
              {
                name: this.$t('overview_dynamic.order_status_dict["待派工"]'),
                value: res.payload["待派工"] || 0,
              },
            ],
          });
        }
      });
    },
    //状态分析
    getOrderStatusAnalysis() {
      let params = {
        start:
          moment(
            this.repairDate2.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate2.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      orderStatusAnalysis(params).then((res) => {
        if (res && res.payload) {
          console.log(res);
          var list1 = [];
          var list2 = [];
          var list3 = [];
          var monthList = [];

          for (var i in res.payload) {
            monthList.push(i);
            list1.push(res.payload[i]["新增数量"]);
            list2.push(res.payload[i]["完成数量"]);
            list3.push(res.payload[i]["未完成"]);
          }
          console.log(list1, list2, list3, monthList);
          workOrderStatisticsEcharts({
            chartDom: document.getElementById("workOrderStatisticsEchart"),
            text: this.$t("base.no-data"),
            unit: this.$t('overview_static.common["单"]'),
            monthList: monthList,
            list1: list1,
            list2: list2,
            list3: list3,
            name1: this.$t("overview_static.work_order_page.new_orders"),
            name2: this.$t("overview_static.work_order_page.complete_orders"),
            name3: this.$t("overview_static.work_order_page.incomplete_order"),
          });
        }
      });
    },
    getOrderType() {
      let params = {
        start:
          moment(
            this.repairDate3.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate3.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      orderType(params).then((res) => {
        if (res && res.payload) {
          console.log(res);
          opportunityEcharts({
            chartDom: document.getElementById("opportunity"),
            unit: this.$t('overview_static.common["单"]'),
            allNum:
              (res.payload["1"] || 0) +
              (res.payload["2"] || 0) +
              (res.payload["3"] || 0) +
              (res.payload["4"] || 0) +
              (res.payload["5"] || 0),
            dataList: [
              {
                name: this.$t('overview_dynamic["设备维修"]'),
                value: res.payload["1"] || 0,
              },
              {
                name: this.$t('overview_dynamic["设备保养"]'),
                value: res.payload["2"] || 0,
              },
              {
                name: this.$t('overview_dynamic["安装调试"]'),
                value: res.payload["3"] || 0,
              },
              {
                name: this.$t('overview_dynamic["故障排查"]'),
                value: res.payload["4"] || 0,
              },
              {
                name: this.$t('overview_dynamic["点巡检"]'),
                value: res.payload["5"] || 0,
              },
              //   {
              //     name: this.$t('overview_dynamic.report_dict["服务报告"]'),
              //     value: res.payload["服务报告"] || 0,
              //   },
            ],
          });
        }
      });
    },
    getOrderFeedback() {
      let params = {
        start:
          moment(
            this.repairDate4.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate4.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      orderFeedback(params).then((res) => {
        if (res && res.payload) {
          console.log(res);
          this.timeList = [
            {
              name: this.$t(
                "overview_static.work_order_page.ave_response_speed"
              ),
              value: res.payload["平均响应时间"] || 0,
            },
            {
              name: this.$t("overview_static.work_order_page.response_to_arr"),
              value: res.payload["平均到达时间"] || 0,
            },
            {
              name: this.$t("overview_static.work_order_page.ave_fix"),
              value: res.payload["平均修复时间"] || 0,
            },
          ];
          this.customerSatisfaction =
            res.payload["客户满意度得分"] &&
            res.payload["客户满意度得分"] != "-"
              ? res.payload["客户满意度得分"] 
              : 0;
          scheduleEcharts({
            chartDom: document.getElementById("scheduleEchart"),
            dataList: this.customerSatisfaction,
          });
          pieEcharts({
            chartDom: document.getElementById("inTime"),
            dataList: [res.payload["及时确认率"] || 0],
            title: this.$t("overview_static.work_order_page.responsed_on_time"),
            color: "#246CF9",
          });
          pieEcharts({
            chartDom: document.getElementById("inTime2"),
            dataList: [res.payload["及时关闭率"] || 0],
            title: this.$t("overview_static.work_order_page.closed_on_time"),
            color: "#11CABE",
          });
          pieEcharts({
            chartDom: document.getElementById("inTime3"),
            dataList: [res.payload["完成率"] || 0],
            title: this.$t("overview_static.work_order_page.done"),
            color: "#8371F2EE",
          });
          pieEcharts({
            chartDom: document.getElementById("inTime4"),
            dataList: [res.payload["满意度"] || 0],
            title: this.$t(
              "overview_static.work_order_page.customer_satisfaction"
            ),
            color: "#14ACC1EE",
          });
        }
      });
    },
    getOrderIndustry() {
      let params = {
        start:
          moment(
            this.repairDate5.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate5.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      orderIndustry(params).then((res) => {
        if (res && res.payload) {
          industryEcharts({
            chartDom: document.getElementById("industryEchart1"),
            dataList: [
              {
                name: this.$t('overview_dynamic.industy_dict["化工"]'),
                value: res.payload["化工"] || 0,
              },
              {
                name: this.$t('overview_dynamic.industy_dict["油气"]'),
                value: res.payload["油气"] || 0,
              },
              {
                name: this.$t('overview_dynamic.industy_dict["电力"]'),
                value: res.payload["电力"] || 0,
              },
              {
                name: this.$t('overview_dynamic.industy_dict["造纸"]'),
                value: res.payload["造纸"] || 0,
              },
              {
                name: this.$t('overview_dynamic.industy_dict["核电"]'),
                value: res.payload["核电"] || 0,
              },
              {
                name: this.$t('overview_dynamic.industy_dict["通用"]'),
                value: res.payload["通用"] || 0,
              },
            ],
            nameList: [
              this.$t('overview_dynamic.industy_dict["化工"]'),
              this.$t('overview_dynamic.industy_dict["油气"]'),
              this.$t('overview_dynamic.industy_dict["电力"]'),
              this.$t('overview_dynamic.industy_dict["造纸"]'),
              this.$t('overview_dynamic.industy_dict["核电"]'),
              this.$t('overview_dynamic.industy_dict["通用"]'),
            ],
            name: this.$t("overview_static.work_order_page.order_amount"),
            unit: this.$t('overview_static.common["单"]'),
          });
        }
      });
    },
    getMonthlyWorkload() {
      let params = {
        start:
          moment(
            this.repairDate6.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate6.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      monthlyWorkload(params).then((res) => {
        if (res && res.payload) {
          var list1 = [];
          var list2 = [];
          var list3 = [];
          var list4 = [];
          var list5 = [];
          var list6 = [];
          var monthList = [];

          for (var i in res.payload) {
            monthList.push(i);
            list1.push(res.payload[i]["1"]);
            list2.push(res.payload[i]["2"]);
            list3.push(res.payload[i]["3"]);
            list4.push(res.payload[i]["4"]);
            list5.push(res.payload[i]["5"]);
            list6.push(res.payload[i]["workload"]);
          }
          lineEchart({
            chartDom: document.getElementById("industryEchart"),
            monthList: monthList,
            list1: list1,
            list2: list2,
            list3: list3,
            list4: list4,
            list5: list5,
            list6: list6,
            name1: this.$t('overview_dynamic["设备维修"]'),
            name2: this.$t('overview_dynamic["安装调试"]'),
            name3: this.$t('overview_dynamic["故障排查"]'),
            name4: this.$t('overview_dynamic["设备保养"]'),
            name5: this.$t('overview_dynamic["点巡检"]'),
            name6: this.$t('overview_dynamic["工单负荷"]'),
            unit: this.$t('overview_static.common["单"]'),
          });
        }
      });
    },
    skipPage(path) {
      this.pathType = path;
      this.$router.push("/" + path);
    },
    moment,
    //全屏
    fullele() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        null
      );
    },

    //判断是否全屏
    isFullScreen() {
      return !!(document.webkitIsFullScreen || this.fullele());
    },
    //退出全屏
    exitFullscreen() {
      this.fullscreen = false;

      if (document.exitFullScreen) {
        document.exitFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    //全屏
    full(ele) {
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },
    //切换是否全屏 全屏按钮要执行的方法
    toggleFullScreen() {
      if (this.isFullScreen()) {
        this.exitFullscreen();
      } else {
        this.fullscreen = true;
        this.full(document.getElementById("workOrder")); //要设置全屏的元素
      }
    },
    changeLang(lang) {
      this.language = lang;
      localStorage.setItem("language", lang);
      // 设置i18n.locale 组件库会按照上面的配置使用对应的文案文件
      // this.$i18n.locale = lang;
      window.location.reload();
    },
  },
  computed: {
    icon() {
      return this.fullscreen ? "ri-fullscreen-exit-line" : "ri-fullscreen-line";
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    logoutUrl() {
      return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/") + "/logout";
    },
  },
  mounted() {
    this.getOrderStatus();
    this.getOrderStatusAnalysis();
    this.getOrderType();
    this.getOrderFeedback();
    this.getOrderIndustry();
    this.getMonthlyWorkload();
    // tendencyEcharts({
    //   chartDom: document.getElementById("workOrderTendencyEchart0"),
    // });
    // tendencyEcharts({
    //   chartDom: document.getElementById("workOrderTendencyEchart1"),
    // });
    // tendencyEcharts({
    //   chartDom: document.getElementById("workOrderTendencyEchart2"),
    // });
    // tendencyEcharts({
    //   chartDom: document.getElementById("workOrderTendencyEchart3"),
    // });
  },
};
</script>

<style scoped>
.menuActive {
  border-radius: 0.625rem;
  background: linear-gradient(
      180deg,
      rgba(254, 200, 241, 0.9) 0%,
      rgba(237, 146, 215, 0) 40.39%
    ),
    radial-gradient(
      96.63% 140.33% at 76.68% 66.67%,
      rgba(96, 46, 166, 0) 0%,
      rgba(201, 119, 214, 0.5) 100%
    );
  background-blend-mode: overlay, normal;
  /* Sign Up button */
  box-shadow: 0px 0.625rem 0.625rem 0px rgba(0, 0, 0, 0.1),
    0px 0px 0.3125rem 0px #fface4 inset, 0px -0.0625rem 0.5rem 0px #9375b6 inset;
}
.cardCss {
  padding: 0.625rem;
  border-radius: 1.25rem;
  background: linear-gradient(
    152deg,
    rgba(49, 46, 46, 0.4) 0%,
    rgba(69, 68, 65, 0.4) 100%
  );
  box-shadow: 0px 1.25rem 3.8125rem 0px rgba(16, 20, 28, 0.6);
  border-top: 0.0625rem solid #b6b7bc3f;
  border-left: 0.0625rem solid #b6b7bc3f;
  border-right: 0.0625rem solid #b6b7bc3f;
}
.btnClass {
  cursor: pointer;
  border-radius: 0.5rem;
  background: linear-gradient(143deg, #363e52 0%, #2b3242 100%);
  box-shadow: 8.5463rem 9.6069rem 18.4520931243896.3125rem 0px
    rgba(61, 73, 100, 0.3) inset;
}
.clickActive {
  border-radius: 1.4623rem;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(255, 255, 255, 0.3) 100%
    ),
    rgba(111, 111, 111, 0.1);
  backdrop-filter: blur(5.3656rem);
}
</style>
